import React from 'react'
import CancelIcon from '@mui/icons-material/Cancel';
import { Button, useTheme } from '@mui/material';

interface CancelFiltersButtonProps {
    onClick: () => void
}

const CancelFiltersButton: React.FC<CancelFiltersButtonProps> = ({ onClick }: CancelFiltersButtonProps) => {
    const theme = useTheme();
    return (
        <Button size='small' color='error' style={{ textTransform: 'none', maxHeight: 40, marginTop: theme.spacing(2) }} onClick={onClick}>
            <CancelIcon fontSize='small' style={{ marginRight: theme.spacing(1) }} />
            Reset All
        </Button>
    )
}

export default CancelFiltersButton